import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { WaitingOnClientProgressionProActions } from '@/features/jobs/details/components/JobProgressionCard/WaitingOnClientProgressionProActions'

export interface WaitingOnClientProgressionProActionsContainerProps {
  vm: JobProgressionViewModel
}

export const WaitingOnClientProgressionProActionsContainer = observer(
  function WaitingOnClientProgressionProActionsContainer({
    vm,
  }: WaitingOnClientProgressionProActionsContainerProps) {
    return (
      <WaitingOnClientProgressionProActions
        containsExtensionRejected={vm.containsExtensionRejected}
        onUploadRejectionConfirmation={vm.viewExtensionDocumentCreationModal}
      />
    )
  },
)
